/* Personalised patch cards use the shared verified cart transport and lock. */
(() => {
  function register() {
    if (!window.K9NativeOffer || customElements.get('k9-patch-offer')) return;
    const { Base, state } = window.K9NativeOffer;
    class K9PatchOffer extends Base {
      static items(config, mode, choices, name, phone) {
        const patch = config.products.patch.variants.find(v => String(v.id) === String(choices.patch));
        const harness = config.products.harness.variants.find(v => String(v.id) === String(choices.harness));
        if (!patch?.available || (mode === 'bundle' && !harness?.available)) return null;
        const properties = { 'Nom du Chien': name.trim() };
        if (phone.trim()) properties['Téléphone'] = phone.trim();
        const items = [{ id: patch.id, quantity: 1, properties }];
        if (mode === 'bundle') items.unshift({ id: harness.id, quantity: 1 });
        return items;
      }

      static validation(name, phone) {
        if (name.trim().length < 2 || name.trim().length > 15) return 'name';
        if (phone.trim() && (phone.trim().length < 10 || phone.trim().length > 17)) return 'phone';
        return null;
      }

      get cartPatch() { return this.mode === 'cart' && this.localName === 'k9-patch-offer'; }

      static patchDimensions(title) {
        const dimensions = /^(11\s*[x×]\s*3|16\s*[x×]\s*5)(?:\s*cm)?$/iu.exec(String(title || '').trim());
        return dimensions ? dimensions[1].replace(/\s*[x×]\s*/u, ' × ') + ' cm' : String(title || '');
      }

      connectedCallback() {
        let pendingInput;
        if (!this.patchMounted) {
          this.patchMounted = true;
          pendingInput = { fields: {}, open: this.querySelector('.k9-patch-offer__options')?.open };
          for (const key of ['name', 'phone']) {
            const input = this.querySelector(`[data-field="${key}"]`);
            if (typeof input?.defaultValue === 'string' && input.value !== input.defaultValue) {
              pendingInput.fields[key] = input.value;
            }
          }
        }
        super.connectedCallback();
        if (pendingInput) {
          if (Object.keys(pendingInput.fields).length) {
            Object.assign(state, pendingInput.fields);
            this.synchronise();
            this.update();
          }
          if (pendingInput.open) { this.details.open = true; this.draft.open = true; }
        }
      }

      nativeFields() {
        const patchId = String(this.config.products.patch.id);
        const owner = this.mode === 'cart'
          ? document.querySelector(`k9-patch-offer[data-mode="bundle"][data-page-product="${patchId}"]`)
          : this;
        if (String(owner?.dataset.pageProduct) !== patchId) return {};
        const product = Array.from(document.querySelectorAll('gp-product')).find(el => !el.closest('gp-sticky')
          && el.querySelector('input[name="properties[Nom du Chien]"]'));
        return {
          name: product?.querySelector('input[name="properties[Nom du Chien]"]'),
          phone: product?.querySelector('input[name="properties[Téléphone]"]'),
        };
      }

      synchronise() {
        const native = this.nativeFields();
        for (const key of ['name', 'phone']) {
          if (!native[key] || native[key].value === state[key]) continue;
          native[key].value = state[key];
          for (const type of ['input', 'change', 'keyup']) native[key].dispatchEvent(new Event(type, { bubbles: true }));
        }
        for (const offer of document.querySelectorAll('k9-patch-offer')) if (offer.config) offer.reflect();
      }

      reflect() {
        for (const key of ['name', 'phone']) this.querySelector(`[data-field="${key}"]`).value = state[key];
        this.querySelector('[data-count]').textContent = `${state.name.length}/15`;
        this.reflectNameGate();
      }

      update() {
        super.update();
        this.reflectNameGate();
      }

      // Drawer card: the add button looks unavailable until the required name is valid, yet stays
      // focusable; pressing it opens the form and focuses the name (Base.submit validation).
      reflectNameGate() {
        if (!this.cartPatch || !this.button) return;
        const waiting = !this.button.disabled && this.constructor.validation(state.name, '') === 'name';
        if (waiting) this.button.setAttribute('aria-disabled', 'true');
        else this.button.setAttribute('aria-disabled', String(Boolean(this.button.disabled)));
        const hint = this.querySelector('[data-name-hint]');
        if (hint?.id && waiting) this.button.setAttribute('aria-describedby', hint.id);
        else this.button.removeAttribute?.('aria-describedby');
      }

      showFieldError(field, text) {
        const input = this.querySelector(`[data-field="${field}"]`);
        input.setAttribute('aria-invalid', String(Boolean(text)));
        const error = this.querySelector(`[data-error="${field}"]`);
        error.textContent = text;
        error.hidden = !text;
      }

      updatePresentation() {
        const patch = this.config.products.patch?.variants.find(v => String(v.id) === this.draft.choices.patch);
        const price = this.querySelector('[data-price="patch"]');
        // Common drawer format « 11,90 € », as the other offer cards.
        if (price && patch) price.textContent = new Intl.NumberFormat(this.config.locale || 'fr',
          { style: 'currency', currency: this.config.currency || 'EUR' }).format(patch.price / 100);
        if (this.cartPatch) {
          const dimensions = this.querySelector('[data-patch-dimensions]');
          if (dimensions) dimensions.textContent = this.constructor.patchDimensions(patch?.title);
        }
      }
    }
    customElements.define('k9-patch-offer', K9PatchOffer);
  }
  if (window.K9NativeOffer) register();
  else document.addEventListener('DOMContentLoaded', register, { once: true });
})();
